import React, { createContext, useState, ReactNode } from 'react';
import { Item, ObjectGeneric } from '../../../../../../../utils/types/generals';
import { Dayjs } from 'dayjs';
import { EvidencesFormat } from '../../FormCorrective/Interfaces';
import { useParams } from 'react-router-dom';
import { EvidencesTypeValueEnum } from '../../../../../../../utils/enums/evidences';

// Keep existing interfaces
export interface SubcategoryInterface {
  id: number;
  name: string;
  categoryId: number;
  requestText: boolean;
  textRequest?: string
  text: boolean;
  priorityId: number;
  supplierId: number | null;
  priority: {
    id: number;
    name: string;
  };
  user: {
    id: number;
    curp: string;
    firstName: string;
    lastName: string;
    email: string;
  } | null;
  dropList: DropListSubCategorie[];
  version?:number;
}

export interface CategoryInterface {
  id: number;
  name: string;
  subcategories: SubcategoryInterface[];
}

export interface SelectedSubcategoryInterface {
  id: number;
  name: string;
  categoryName: string;
  categoryId:number;
  requestText?: boolean
  textRequest?: string;
  user: {label:string, value:number} | null;
  dropList: DropListSubCategorie[];
  idArray?:number;
}

export interface DropListSubCategorie {
  label: string;
  value: number;
  requestText: boolean;
  textRequest?: string
  dropList: DropListSubCategorie[]
  currentNode?:number
}

export interface IdSubOptionInterface {
  areaId:number,
  departmentId:number,
  subcategories:{
    subcategoryId: number;
    subcategory: string;
    category: string
  }[],
  userAssigned?:number
}

// Internal form data for managing state
interface FormData {
  subcategoryText: string;
  selectedCategory?: {name:string, id:number} | null;
  notifyAssignment?: boolean;
  selectedSubcategories?: SelectedSubcategoryInterface[] | null;
  selectedSubcategoriesCopy?: SelectedSubcategoryInterface[] | null;
  area?: ObjectGeneric | null;
  department?: ObjectGeneric | null;
  selectedUnit: ObjectGeneric | null;
  selectedTime?: ObjectGeneric | null;
  selectedFrecuency?: ObjectGeneric | null;
  selestedQuestionnarie?: ObjectGeneric | null;
  selectedEvery?: ObjectGeneric | null;
  selectedPriority: string | null;
  selectedProvider: ObjectGeneric | null;
  selectedProviderCopy: ObjectGeneric | null;
  startDate?: Dayjs | null;
  endDate?: Dayjs | null;
  executionDate?: Dayjs | null;
  executionEndDate?: Dayjs | null;
  title: string | null;
  description: string | null;
  categories: CategoryInterface[];
  categoriesCopy: CategoryInterface[];
  evidences: EvidencesFormat;
  evidencesDataEdit?: {
    evidenceTypeId: EvidencesTypeValueEnum;
    originalName: string;
    url: string;
  }[],
  categoryIdSelected?: number
  flag?:boolean;
  idSubOption: IdSubOptionInterface | undefined
}

// Data structure for API submission
export interface SubmitFormData {
  areaId: number;
  departmentId: number;
  categories: {
    categoryId: number;
    category: string;
    subcategoryId: number;
    subcategory: string;
    priorityId: number;
    priority: string;
    requestText: boolean;
    userAssignId: number;
  }[];
  storeId: number;
  priorityId: number;
  userAssignId: number;
  name: string;
  description: string;
  evidences: any[];
}

interface FormContextType {
  formData: FormData;
  updateFormData: (data: Partial<FormData>) => void;
  setConfig: React.Dispatch<any>
  config: any
  id: string | undefined;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setConfigCopy: React.Dispatch<React.SetStateAction<undefined>>
  configCopy: undefined
}

export const FormContext = createContext<FormContextType>({
  formData: {},
  updateFormData: () => { }
});

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [formData, setFormData] = useState<FormData>({});
  const [config, setConfig] = useState<any>(null);
  const { id } = useParams()
  const [isEdit, setIsEdit] = useState(false)
  const [configCopy, setConfigCopy] = useState()

  const updateFormData = (newData: Partial<FormData>) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData, config, setConfig, id, isEdit, setIsEdit, configCopy, setConfigCopy }}>
      {children}
    </FormContext.Provider>
  );
};